import React, { useEffect, useState } from 'react';
import { DataTableBackendPagination } from 'shared/ui/Table';
import { columnConfigDownloadPrize } from 'widgets/downloads/model';
import { toast } from 'react-toastify';
import { downloadNotLoadedPrizes } from 'entities/downloads/prizes/api/downloadNotLoadedPrizes';
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { useGetDownloadsPrizeMutation } from 'entities/downloads/prizes/api';
import { mapDownloadPrizesToTableRenderType } from '../utils';

export const DownloadsCodesTable = () => {
  const [downloadPrizesMethod, { data: downloadPrizes, error: downloadPrizesError }] = useGetDownloadsPrizeMutation();
  const [pagination, setPagination] = useState({
    rowsPerPage: 5,
    page: 0,
  });

  useEffect(() => {
    downloadPrizesMethod({
      upload_type: 'prize_codes',
      size: pagination.rowsPerPage,
      page: pagination.page + 1,
    }).then((res) => {
      if ((res as { error: FetchBaseQueryError }).error) {
        toast.error('Произошла ошибка при загрузке данных', {
          position: toast.POSITION.TOP_RIGHT,
          toastId: Symbol('toastId').toString(),
        });
      }
    });
  }, [pagination]);

  const handleDownloadRow = (idx: number) => {
    downloadNotLoadedPrizes({
      url: downloadPrizes?.items[idx].err_file ?? '',
      fileName: downloadPrizes?.items[idx].file_name ?? '',
    });
  };

  const handleUpdateTable = () => {
    downloadPrizesMethod({
      upload_type: 'prize_codes',
      size: pagination.rowsPerPage,
      page: 1,
    }).then(() => {
      if (!downloadPrizesError) {
        toast.success('Данные успешно обновлены', {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error('Произошла ошибка при загрузке данных', {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    });
  };

  return (
    <DataTableBackendPagination
      title="Призы - Таблицы кодов"
      data={downloadPrizes ? mapDownloadPrizesToTableRenderType(downloadPrizes?.items) : []}
      total={downloadPrizes?.total ?? 0}
      pagination={pagination}
      setPagination={setPagination}
      columnConfig={columnConfigDownloadPrize}
      emptyListTitle="Нет загрузок для отображения"
      onDownloadRow={handleDownloadRow}
      onUpdateTable={handleUpdateTable}
      buttonsController
    />
  );
};
